export default __webpack_public_path__ + "static/media/263697.7e815450.png";